import React from "react";
import { useState, useEffect } from "react";
import { ArrowRightCircle } from "react-bootstrap-icons";
import { Container, Row, Col } from "react-bootstrap";
import myPic from "../assests/img/myimage.jpeg";
import "animate.css";
import TrackVisibility from "react-on-screen";

export const Banner = () => {
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const toRotate = ['Web developer', "React.js Developer", "Mern Stack Developer"];
  const [text, setText] = useState("");
  const period = 2000;
  const [index, setIndex] = useState(1);
  const [delta, setDelta] = useState(300 - Math.random() * 100);

  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta);

    return () => {
      clearInterval(ticker);
    };
  }, [text]);

  const tick = () => {
    let i = loopNum % toRotate.length;
    let fullText = toRotate[i];
    let updatedText = isDeleting
      ? fullText.substring(0, text.length - 1)
      : fullText.substring(0, text.length + 1);

    setText(updatedText);
    if (isDeleting) {
      setDelta((prevDelta) => prevDelta / 2);
    }

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setIndex((prevIndex) => prevIndex - 1);
      setDelta(period);
    } else if (isDeleting && updatedText === "") {
      setIsDeleting(false);
      setLoopNum(loopNum + 1);
      setIndex(1);
      setDelta(500);
    } else {
      setIndex((prevIndex) => prevIndex + 1);
    }
  };

  return (
    <>
      <section className="banner" id="home">
        <Container>
          <Row className="align-items-center">
            <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
            {
              ({ isVisible }) =>
            
            <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
              <span className="tagline">Welcome to my PortFolio</span>
              <h1>
                {`Hi, I'm Touseef Zakria `}
                <span className="wrap">{text}</span>
              </h1>
              <p>
              I am a skilled React.js developer with a strong focus on building dynamic and responsive user interfaces. With expertise in modern front-end technologies, I strive to create seamless web applications.
              </p>
              <button onClick={() => console.log("connect")}>
                Let's Connect <ArrowRightCircle size={25} />
              </button>
              </div>}
              </TrackVisibility>
            </Col>
            <Col xs={12} md={6} xl={5}>
              <img src={myPic} alt="Header img" style={{ height: "700px", borderRadius: "30%"}}></img>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};
